var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBenefitsi = function SvgBenefitsi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m20.777 7.762-2.251-3.941A1.61 1.61 0 0 0 17.132 3H6.868a1.61 1.61 0 0 0-1.393.82L3.222 7.763A1.71 1.71 0 0 0 3.3 9.567L10.681 20.3a1.59 1.59 0 0 0 2.638 0L20.7 9.569a1.71 1.71 0 0 0 .077-1.807m-1.842-.007H16.6l.888-2.582zm-4.511 1.6L12 17.472 9.576 9.358zm-4.047-1.6L12 5.247l1.624 2.508zm4.761-.555-1.67-2.579 2.554.007zm-6.275 0-.892-2.6 2.568.007zm1.29 9.54L5.1 9.358h2.847zm5.9-7.384h2.883l-5.08 7.351zM6.522 5.2 7.4 7.755H5.041z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBenefitsi);
export default ForwardRef;